// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'

import '@/assets/css/common.css'
import 'element-ui/lib/theme-chalk/index.css'
import myaxios from '@/assets/js/myaxios.js'
import store from '@/vuex/store.js'
import App from './App'
import Router from 'vue-router'
import VideoPlayer from 'vue-video-player'
import MTop from '@/components/top/mtop.vue'
import VCharts from 'v-charts'
import Share from 'vue-social-share'
import echarts from 'echarts'
import 'vue-social-share/dist/client.css'
import '@/assets/fonts/iconfont.css'

import Calendar from 'vue-mobile-calendar' // 底部弹出框日期选择
import 'vue-layer-mobile/need/layer.css'
import layer from 'vue-layer-mobile' // 手机弹出框
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.prototype.$echarts = echarts
Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.use(VCharts)

Vue.use(Calendar)
Vue.use(layer)

Vue.use(Share)
Vue.use(ElementUI)
Vue.use(myaxios)
// console.log(process.env)
Vue.component(MTop.name, MTop)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/main.js